export default __webpack_public_path__ + "static/media/cwsuiteWhite.a13af9ba.svg";